
// === Dawn cart-system globals ===
// Required by: cart.js, cart-drawer.js, product-form.js, product-info.js, quick-add.js
// These constants are normally part of Dawn's global.js but were missing
// in our customized Eisenberg version. Adding them here so the cart drawer
// can debounce quantity changes and use the PubSub event system.
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

//*****Default DAWN theme code START*****

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  
  if (elementToFocus) elementToFocus.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}


customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

//*****Default DAWN theme code END*****

//*****Custom scripts*****



function cookiesButtonT() {
  const currentURL = window.location.href;
  const parts = currentURL.split('/');
  const trimmedLanguageNow = parts[3]?.slice(0, 2);

  if (trimmedLanguageNow === 'en' || trimmedLanguageNow === 'us') {
    const cookiesElements = document.querySelector('.product__recently-viewed-section');
    if (cookiesElements) {
      const cookiesButtons = cookiesElements.querySelectorAll('button');
      cookiesButtons.forEach((button) => {
        button.textContent = 'Add to cart';
      });
    }
  }
}

function hideHeaderInLogin() {
  const headerLogin = document.querySelector('.header-with-text .wrapper');
  if (headerLogin) headerLogin.style.display = 'none';
}

function displayHeaderInLogin() {
  const headerLogin = document.querySelector('.header-with-text .wrapper');
  if (headerLogin) headerLogin.style.display = 'block';
}

function hideCarouselSlideWithThumb() {
  document.querySelectorAll('.product__top-left .product__carousel-slide').forEach((slide) => {
    const img = slide.querySelector('img');
    const srcset = img?.getAttribute('srcset') || '';
    if (srcset.includes('_THUMB_')) slide.remove();
  });

  document.querySelectorAll('.cart-drawer-product__images img').forEach((img) => {
    const srcset = img?.getAttribute('srcset') || '';
    if (srcset.includes('_THUMB_')) img.remove();
  });
}

function carouselNavigation(dotsSelector, slideSelector) {
  const dots = document.querySelectorAll(dotsSelector);
  const slides = document.querySelectorAll(slideSelector);

  dots.forEach((dot, index) => {
    if (index > 1) {
      dot.addEventListener('click', () => {
        const visibleImages = Array.from(slides).filter(
          (img) => window.getComputedStyle(img).display === 'block'
        );
        const targetImage = visibleImages[index - 2];
        if (targetImage) {
          targetImage.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  });
}

function carouselThumbnails() {
  carouselNavigation('.product__carousel-thumb', '.img_lg');
}

function carouselDots() {
  carouselNavigation('.product__carousel-bullet', '.img_lg');
}


function deleteLangPopUp () {
     const popupContainer = document.querySelector('.popupContainer');
        document.body.removeChild(popupContainer);
      };

function toggleDropdown(dropdownId) {
    /* Scope to the popup that triggered the call: duplicate ids injected by
       app widgets on the homepage made the global getElementById grab the
       wrong node. Falls back to document for safety. (fix C6) */
    var scope = (typeof event !== 'undefined' && event && event.target)
        ? (event.target.closest('.popupContainer') || document)
        : document;
    var dropdown = scope.querySelector('#' + dropdownId) || document.getElementById(dropdownId);
    if (!dropdown) return;
    scope.querySelectorAll('.dropdown-contentPopUp').forEach(function(item) {
        if (item !== dropdown) {
            item.style.display = 'none';
            item.classList.remove('show');
        }
    });
    /* Clear the inline display:none set above on a previous toggle,
       otherwise the .show class can never win again. */
    dropdown.style.display = '';
    dropdown.classList.toggle('show');
}

function selectOption(value) {
    var selectedOption = event.target.textContent;
    var dropdownContainer = event.target.parentNode.parentNode;
    dropdownContainer.setAttribute('data', value);
   
    const targetUl = dropdownContainer.querySelector('ul');
    targetUl.style.display = 'none';
    targetUl.classList.remove('show')
   
    var selectedOptionDiv = dropdownContainer.querySelector('.selectedOption');
    selectedOptionDiv.textContent = selectedOption;
    toggleDropdown(dropdownContainer.querySelector('ul').id);
}


function localPopUp_Form() {
  // const selectedOptionL = document.querySelector('.selectedOptionL');
  // setCookie('saveCountry', selectedOptionL);
  let selectCountryPopUp = document.querySelector('.selectCountryPopUp').getAttribute('data');
  let selectLangPopUp = document.querySelector('.selectLangPopUp').getAttribute('data');
  let formButton = document.querySelector('#localPopUp_Form_Button');
  let inputC = document.querySelector('#localPopUp_Form_1');
  let inputL = document.querySelector('#localPopUp_Form_2');
  inputC.value = selectCountryPopUp;
  inputL.value = selectLangPopUp;
  formButton.click();

}

function generateListItems2(data) {
    var listItemsHTML = ""; 

    var keys = Object.keys(data); 

    for (var i = 0; i < keys.length; i++) {
        var currentKey = keys[i];

        listItemsHTML += `<li onclick="selectOption('${data[currentKey]}')">${currentKey}</li>`;
    }

    return listItemsHTML; 
}

  

function generateListItems(data1, data2) {
   const countriesNotEU = [
  "AL", "DZ", "AD", "AO", "AR", "AM", "AU", "BS", "BH", "BY", "BZ", "BA", "CA", "CO", "EG", 
  "GF", "GE", "GI", "GP", "GG", "IS", "IN", "ID", "IL", "JP", "JE", "XK", "LI", "MK", "CN", 
  "MQ", "MX", "MD", "ME", "MA", "NO", "PH", "RE", "SM", "SA", "RS", "SG", "TR", "ZA", "KR", "LK", 
  "CH", "TN", "AE", "US", "UK", "GB", "NZ", "UA", "DO", "KW", "HK", "TW", "TR", "UY"
];
    var listItemsHTML = ""; 

    var keys1 = Object.keys(data1); 
    var keys2 = Object.keys(data2); 

 
    for (var i = 0; i < keys1.length; i++) {
        var currentKey1 = keys1[i];
        var currentKey2 = keys2[i]; 

        let currency = null;
        if (countriesNotEU.includes(currentKey2)) {
          currency = '(US$)';
        } else {
          currency = '(€)';
        }
        
        listItemsHTML += `<li onclick="selectOption('${currentKey2}')">${data1[currentKey1]} ${currency}</li>`; 
    }

    return listItemsHTML; 
}

async function changeLocale() {
    var popupContainer = document.createElement('div');
    var popupContent = document.createElement('div');
  var data = null;
  var currentURL = window.location.href;
  var parts = currentURL.split('/');
  var trimmedLanguageNow = parts[3].slice(0,2);
   switch (trimmedLanguageNow) {
        case 'fr':
        data = await fetchJSON(window.FR_JSON_URL);
        break;
     case 'ru':
       data = await fetchJSON(window.RU_JSON_URL);
        break;
       case 'de':
       data = await fetchJSON(window.DE_JSON_URL);
        break;
       case 'it':
       data = await fetchJSON(window.IT_JSON_URL);
        break;
       case 'zh':
       data = await fetchJSON(window.ZH_JSON_URL);
        break;
       default:
       data = await fetchJSON(window.EN_JSON_URL);
       
       break;
   }

    var formHTML = `
        <div id="localPopUp">
        <img onclick="deleteLangPopUp()" class="langPopUp_Close" src="https://cdn.shopify.com/s/files/1/0665/2798/5877/files/abcrossgrey.svg?v=1709551340">
        <img class="localPopUpLogo" src="https://cdn.shopify.com/s/files/1/0657/4089/8560/files/logo.svg">
        <p style="font-family:FuturaLT-Book !important" class="localPopUpP">${data[12]["WELCOME"]} <span style="font-family:FuturaLT-Book !important" >EISENBERG.COM</span></p>
         <p style="font-family:FuturaLT-Book !important" class="localPopUpP2">${data[12]["Choose1"]}</p>
         
            <input type="hidden" name="_method" value="PUT">
            <div  class="imgPlusSelect">
            
            <div style="margin-left: 10px;" class="selectCountryPopUp" onclick="toggleDropdown('countryDropdown')">
    <div style="font-family:FuturaLT-Book !important" data="" class="selectedOption selectedOptionС">-</div>
    <ul style="font-family:FuturaLT-Book !important"  id="countryDropdown" class="dropdown-contentPopUp">
        ${generateListItems(data[13], data[14])}      
    </ul>
</div>
</div>
<p style="font-family:FuturaLT-Book !important" class="localPopUpP2 aaa">${data[12]["Choose2"]}</p>
<div  class="imgPlusSelect">

<div style="margin-left: 10px; font-family:FuturaLT-Book !important" class="selectLangPopUp" onclick="toggleDropdown('langDropdown')">
    <div style="font-family:FuturaLT-Book !important" class="selectedOption selectedOptionL">-</div>
    <ul id="langDropdown" class="dropdown-contentPopUp">
        ${generateListItems2(data[15])}
    </ul>
</div>

            </div>
        
            <button onclick="setCookie('validate', 'true', 30);localPopUp_Form()" id="submitButton" style="font-family:FuturaLT-Pro-75-bold;cursor:pointer">${data[12]["button"]}</button>
        </div>
    `;

    popupContainer.style.position = 'fixed';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    popupContainer.style.height = '100%';
    popupContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    popupContainer.style.zIndex = '999999999999999';
    popupContainer.style.display = 'flex';
    popupContainer.style.justifyContent = 'center';
    popupContainer.style.alignItems = 'center';

    // popupContent.style.width = '400px';
    // popupContent.style.height = '300px';
    popupContent.style.backgroundColor = '#fff';
    popupContent.style.border = '1px solid #ccc';
    popupContent.innerHTML = formHTML;
  popupContent.classList.add('popUpLangDiv')
  popupContainer.classList.add('popupContainer')

    popupContainer.appendChild(popupContent);
    document.body.appendChild(popupContainer);

    popupContainer.addEventListener('click', function(e) {
        if (e.target === popupContainer) {
            document.body.removeChild(popupContainer);
        }
    });

  const footerCountryName = document.querySelector('.footerCountryName').textContent;
let footerLangName = document.querySelector('.footerLangName').textContent;
   

const selectCountryPopUp = document.querySelector('.selectedOptionС');
const headerCountry = document.querySelector('.headerCountry');
 const popUpCurrency = document.querySelector('.headerCurrency').textContent;
selectCountryPopUp.textContent = footerCountryName  + ' (' + popUpCurrency + ')';
  const selectCountryPopUpForAtt = document.querySelector('.selectCountryPopUp');

selectCountryPopUpForAtt.setAttribute('data', headerCountry.textContent);


  const selectLangPopUp = document.querySelector('.selectedOptionL');
  selectLangPopUp.textContent = footerLangName;

  popupContainer.addEventListener('click', function(e) {
  
    if (!e.target.closest('.imgPlusSelect')) {    
      
        var allOpenDropdowns = popupContainer.querySelectorAll('.show');
      if (allOpenDropdowns.length > 0 ) {
        allOpenDropdowns.forEach((open) => {
          open.classList.remove('show');
        });
      }
    }       
});



// POZOR -- dont delete
    document.getElementById('submitButton').addEventListener('click', function(e) {
        e.preventDefault(); 
      
 const countriesNotEU = [
  "AL", "DZ", "AD", "AO", "AR", "AM", "AU", "BS", "BH", "BY", "BZ", "BA", "CA", "CO", "EG", 
  "GF", "GE", "GI", "GP", "GG", "IS", "IN", "ID", "IL", "JP", "JE", "XK", "LI", "MK", "CN", 
  "MQ", "MX", "MD", "ME", "MA", "NO", "PH", "RE", "SM", "SA", "RS", "SG", "ZA", "KR", "LK", 
  "CH", "TN", "AE", "US", "UK","GB", "NZ", "UA", "DO", "KW", "HK", "TW", "TR", "UY"
];

        // var countryCode = document.querySelector('select[name="country_code"]').value;
      // var languageCode = document.querySelector('select[name="language_code"]').value;
      let countryCode = document.querySelector('.selectCountryPopUp').getAttribute('data');
      let languageCode = document.querySelector('.selectLangPopUp').getAttribute('data');


      
      if (!languageCode) {
      languageCode = document.querySelector('.headerLang_').textContent;
      }



      const url = window.location.href;
const words = ['products', 'blogs', 'collections', 'pages', 'account']; 

// Разбиваем URL на части
const urlParts = url.split('/');

// Ищем наличие ключевых слов
const keywordIndex = urlParts.findIndex(part => words.includes(part));

let partAfterThirdSlash = '';

if (keywordIndex !== -1) {
    // Если ключевое слово найдено, извлекаем часть URL после него
    partAfterThirdSlash = urlParts.slice(keywordIndex).join('/');
    partAfterThirdSlash = `/${partAfterThirdSlash}`;
} else {
    // Если ключевые слова не найдены
    const urlWithoutQuery = url.split('?')[0]; // URL без части после знака вопроса
    const slashCount = (urlWithoutQuery.match(/\//g) || []).length; // Подсчет количества "/"

    if (slashCount === 3 && url.includes('?')) {
        // Если всего три знака "/" и есть знак "?", возвращаем часть после знака "?"
        partAfterThirdSlash = url.slice(url.indexOf('?'));
    } else {
        // Если за третьим "/" больше 7 символов, возвращаем эту часть
        if (urlParts[3] && urlParts[3].length > 7) {
            partAfterThirdSlash = "/" + urlParts.slice(3).join('/');
        } else if (urlParts[4]) {
            // Если за четвертым "/" есть часть, возвращаем её
            partAfterThirdSlash = "/" + urlParts.slice(4).join('/');
        }
    }
}

// Выводим результат


      


    
       if (countryCode === 'US') {
    if (languageCode === 'en' || languageCode === '') {
        var redirectURL = "https://us.eisenberg.com/" + partAfterThirdSlash + "?ngr-redirected=1";
        window.location.href = redirectURL;
    } else if (languageCode === 'zh-cn' || languageCode === 'CN') {
        var redirectURL = "https://us.eisenberg.com/" + "zh-cn" + "/" + partAfterThirdSlash + "?ngr-redirected=1";
       
        //alert('stop');
        window.location.href = redirectURL;
    } else {
        var redirectURL = "https://us.eisenberg.com/" + languageCode + "/" + partAfterThirdSlash + "?ngr-redirected=1"; 
        window.location.href = redirectURL; 
    }
} else if (countryCode === 'UK' || countryCode === 'GB') {
    if (languageCode === 'en' || languageCode === '') {
        var redirectURL = "https://intl.eisenberg.com/" + partAfterThirdSlash + "?ngr-redirected=1";
        window.location.href = redirectURL; 
    } else {
        var redirectURL = "https://intl.eisenberg.com/" + languageCode + "/" + partAfterThirdSlash + "?ngr-redirected=1";
        window.location.href = redirectURL; 
    }
} else if (countriesNotEU.includes(countryCode)) {
          if (languageCode === 'en' || languageCode === '') {
            var redirectURL = "https://intl.eisenberg.com/" + 'en' + `-${countryCode}` + "/" + partAfterThirdSlash + "?ngr-redirected=1"; 
            window.location.href = redirectURL;
          } else {
            if (!languageCode.includes('cn')) {
              var redirectURL = "https://intl.eisenberg.com/" + languageCode + `-${countryCode}` + "/" + partAfterThirdSlash + "?ngr-redirected=1"; 

            //alert('stop');
            window.location.href = redirectURL;
            } else {
              var redirectURL = "https://intl.eisenberg.com/" + 'zh' + `-${countryCode}` + "/" + partAfterThirdSlash + "?ngr-redirected=1"; 
             
              //alert('stop');
            window.location.href = redirectURL;
            }
            
          }
        } else {
            document.getElementById('localPopUp').submit();
        }
    });

  
}





function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}

function setCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

window.addEventListener('load', function() {
    
    if (getCookie("validate")) {
        // changeLocaleHelloMess();
        deleteCookie("validate");   
    }
});


function deleteCookie(cookieName) {
 
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}



document.addEventListener('DOMContentLoaded', () => {
   const footerLang = document.querySelectorAll('.parentDiv_FLS_mobile');
  if (footerLang.length > 0) {
     
footerLang[0].remove();
    }
});

function addCssRule(selector, rules) {
  for (let i = 0; i < document.styleSheets.length; i++) {
    const styleSheet = document.styleSheets[i];
    try {
      styleSheet.insertRule(selector + "{" + rules + "}", styleSheet.cssRules.length);
    } catch (err) {
      console.error(err);
    }
  }
}








// cookie helpers
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

// запускаем changeLocale() по префиксу в URL
function checkUrlPrefix() {
  const urlPath = window.location.pathname;
  const pathParts = urlPath.split('/').filter(Boolean);

  if (pathParts.length > 0) {
    const prefix = pathParts[0];
    const validPrefixes = ['fr', 'ru', 'en', 'de', 'it', 'zh', 'cn'];

    const isValid = validPrefixes.some(p => prefix === p || prefix.startsWith(`${p}-`));

    if (isValid && !getCookie('localeChanged')) {
      changeLocale();
      setCookie('localeChanged', 'true', 30);
    }
  }
}

window.addEventListener('load', () => {
  // checkUrlPrefix();
});

/**
 * Market chooser popup (Step 1)
 * - Shows once per user (cookie-based).
 * - INTERNATIONAL -> redirects to https://intl.eisenberg.com/?ngr-redirected=1
 * - EUROPE -> stays on current domain and opens existing locale popup (changeLocale()).
 */
(function initMarketChooser() {
  const COOKIE_NAME = 'market_choice';
  const COOKIE_DAYS = 90;

  const MARKET_URLS = {
    intl: 'https://intl.eisenberg.com/',
    eu: null // stay on current domain
  };

  function hasRedirectFlag() {
    return new URLSearchParams(window.location.search).has('ngr-redirected');
  }

  function openChooser() {
    const el = document.getElementById('marketChooser');
    if (!el) return;

    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
  }

  function closeChooser() {
    const el = document.getElementById('marketChooser');
    if (!el) return;

    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
  }

  function redirectTo(url) {
    const u = new URL(url);

    // Safety marker to prevent redirect loops
    if (!u.searchParams.has('ngr-redirected')) u.searchParams.set('ngr-redirected', '1');

    window.location.href = u.toString();
  }

  function handleChoice(choice) {
    setCookie(COOKIE_NAME, choice, COOKIE_DAYS);

    if (choice === 'intl' && MARKET_URLS.intl) {
      redirectTo(MARKET_URLS.intl);
      return;
    }

    // EU branch: close Step 1 and open Step 2 (existing locale popup)
    closeChooser();

    if (typeof window.changeLocale === 'function') {
      window.changeLocale();
    }
  }

  function bindEvents() {
    const root = document.getElementById('marketChooser');
    if (!root) return;

    root.addEventListener('click', (e) => {
      const close = e.target.closest('[data-market-chooser-close]');
      if (close) {
        closeChooser();
        return;
      }

      const btn = e.target.closest('[data-market-choice]');
      if (!btn) return;

      const choice = btn.getAttribute('data-market-choice');
      if (!choice) return;

      handleChoice(choice);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeChooser();
    });
  }

  function shouldShowChooser() {
    if (getCookie(COOKIE_NAME)) return false;
    if (hasRedirectFlag()) return false;
    return true;
  }

  window.addEventListener('load', () => {
    bindEvents();

    // IMPORTANT:
    // If Step 1 is shown, we deliberately stop here to avoid collisions with checkUrlPrefix()/changeLocale().
    if (shouldShowChooser()) {
      openChooser();
      return;
    }

    // If Step 1 is not shown, your existing auto-locale logic continues as-is (e.g. checkUrlPrefix()).
  });
})();


